import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useNavigationView } from '../../../../../design-system';
import { loadBalancingGroupNav } from './navView';
import OverviewView from './Overview';
import { LoadBalancingGroupProvider } from './Provider';
import SettingsView from './Settings';

const LoadBalancingGroupView: React.FC = () => {
  useNavigationView(loadBalancingGroupNav);

  const { path, url } = useRouteMatch<{ id: string }>();

  return (
    <LoadBalancingGroupProvider>
      <Switch>
        <Route path={`${path}/overview`}>
          <OverviewView />
        </Route>
        <Route path={`${path}/settings`}>
          <SettingsView />
        </Route>
        <Route>
          <Redirect to={`${url}/overview`} />
        </Route>
      </Switch>
    </LoadBalancingGroupProvider>
  );
};

export default LoadBalancingGroupView;
